export default __webpack_public_path__ + "static/media/closet4-1440w.eb12bf7c.png";